module.exports = __webpack_public_path__ + "img/webpayLogo.c73996db.svg";